import React, { useEffect } from 'react'
import NavBar from './NavBar'
import Banner from './Banner'
import { Box,makeStyles, styled} from '@material-ui/core'
import {useDispatch, useSelector} from 'react-redux';
import { getProducts } from '../redux/actions/productActions'
import Slide from  './Slide'
import MidSlide from './MidSlide';
import MidSection from './MidSection';
// const useStyle =makeStyles({
//   const  Component:{
//         padding:10,
//         background:'#F2F2F2'
//     }
// })

const Component =styled(Box)`
    padding:10px;
    background:#F2F2F2;
`;

const Home = () => {

    const {products}=useSelector(state=>state.getProducts)

    const dispatch=useDispatch();
     useEffect(()=>{
        dispatch(getProducts())
     },[dispatch])


    // const classes= useStyle();
    return (
        <>
            <NavBar />
            <Component>
                <Banner />
                <MidSlide products={products} />
                <MidSection />
                <Slide
                    data={products} 
                    title='Discounts for You'
                    timer={false} 
                    multi={true} 
                />
                <Slide
                    data={products} 
                    title='Suggested Items'
                    timer={false} 
                    multi={true} 
                />
                <Slide
                    data={products} 
                    title='Top Selection'
                    timer={false} 
                    multi={true} 
                />
                <Slide
                    data={products} 
                    title='Recommended Items'
                    timer={false} 
                    multi={true} 
                />
            </Component>
        </>
    )
}

export default Home
